
import "./subscription.css";

import Header from "../../components/Header";
import Footer from "../../components/Footer";

import { useEffect } from "react";

/* imagens */
import whatsapp from "../../assets/whats_icon.png";

export default function Subscription() {

    useEffect(() => { window.scrollTo(0, 0); }, []);


    return(
        <div className="context">
                    
            <Header access={0}></Header>
            
            <div className="content">
                <div className="ft_topico">Conheça nossos planos</div>
                <div className="ft_descricao">Confira abaixo todos os nossos planos, escolha em qual ramo se enquadra as suas atividades.</div>
                <div className="ft_descricao">Nossos agentes vão além da prestação de informações, eles podem marcar e remarcar compromissos de acordo com a sua disponibilidade de agenda. Também, coletamos todas as informações do atendimento, para que futuramente você possa fazer a gestão de seus clientes de forma muito mais eficiente.</div>
                <div className="space"></div>

                <div className="subscription_box">
                    <div className="subscription_box_title">
                        <span className="subscription_box_title_text">Plano para</span>
                        <span className="subscription_box_title_item">Médicos</span>
                        <span className="subscription_box_title_space"></span>
                        <span className="subscription_box_title_include">+1 linha exclusiva</span>
                        <span className="subscription_box_title_include">+1 agenda exclusiva</span>
                    </div>
                    <div className="subscription_box_plan">
                        <div className="subscription_box_plan_item">
                            <span className="subscription_box_plan_title">FUNÇÕES DO AGENTE:</span>
                            
                            <span className="subscription_box_plan_list">Prestar atendimento 24 horas por dia e 7 dias na semana;</span>
                            <span className="subscription_box_plan_list">Atender de forma simpática, amigável e objetiva;</span>
                            <span className="subscription_box_plan_list">Prestar informações sobre a clínica ou local de atendimento, endereço, redes sociais e etc;</span>
                            <span className="subscription_box_plan_list">Prestar informações sobre o médico, especialidades e valor de consulta;</span>
                            <span className="subscription_box_plan_list">Prestar informações sobre convênios;</span>
                            <span className="subscription_box_plan_list">Prestar informações sobre exames e seus respectivos valores;</span>
                            <span className="subscription_box_plan_list">Marcar e remarcar consultas e exames de acordo com a disponibilidade de agenda do médico.</span>

                            <span className="subscription_box_plan_title">CANAL DE ATENDIMENTO:</span>
                            <img className="subscription_image1" src={whatsapp}></img>
                            
                            <span className="subscription_box_plan_mensalidade">mensalidade</span>
                            <div className="subscription_box_plan_box_price">
                                <span className="subscription_box_plan_price_cifra">R$</span>
                                <div className="subscription_box_plan_price">299,00</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="subscription_line"></div>

                <div className="subscription_box">
                    <div className="subscription_box_title">
                        <span className="subscription_box_title_text">Plano para</span>
                        <span className="subscription_box_title_item">Esteticistas</span>
                        <span className="subscription_box_title_space"></span>
                        <span className="subscription_box_title_include">+1 linha exclusiva</span>
                        <span className="subscription_box_title_include">+1 agenda exclusiva</span>
                    </div>
                    <div className="subscription_box_plan">
                        <div className="subscription_box_plan_item">
                            <span className="subscription_box_plan_title">FUNÇÕES DO AGENTE:</span>
                            
                            <span className="subscription_box_plan_list">Prestar atendimento 24 horas por dia e 7 dias na semana;</span>
                            <span className="subscription_box_plan_list">Atender de forma simpática, amigável e objetiva;</span>
                            <span className="subscription_box_plan_list">Prestar informações sobre o local de atendimento, endereço, redes sociais e etc;</span>
                            <span className="subscription_box_plan_list">Prestar informações sobre o profissional e suas respectivas especialidades</span>
                            <span className="subscription_box_plan_list">Prestar informações sobre procedimentos e seus respectivos valores;</span>
                            <span className="subscription_box_plan_list">Marcar e remarcar horários de acordo com a disponibilidade de agenda do esteticista.</span>

                            <span className="subscription_box_plan_space"></span>
                            
                            <span className="subscription_box_plan_title">CANAL DE ATENDIMENTO:</span>
                            <img className="subscription_image1" src={whatsapp}></img>
                            
                            <span className="subscription_box_plan_mensalidade">mensalidade</span>
                            <div className="subscription_box_plan_box_price">
                                <span className="subscription_box_plan_price_cifra">R$</span>
                                <div className="subscription_box_plan_price">259,00</div>
                            </div>
                        </div>
                    </div>
                </div>
            
                <span className="subscription_space"></span>
                <span className="subscription_note">Importante:</span>
                <span className="subscription_note">Só será cobrada a mensalidade quando o cliente aderir por vontade própria a assinatura;</span>
                <span className="subscription_note">Você tem o período de sete dias para testar seu agente gratuitamente;</span>
                <span className="subscription_note">Para plano de médicos, os convênios são apenas informativos, não há uma validação do associado em sistemas externos.</span>

            </div>

            <div className="space"></div>
            <div className="space"></div>
            <div className="space"></div>
            
            <Footer access={0}></Footer>

        </div>
    )
}